import { render } from "./UserResults.vue?vue&type=template&id=540be1c7"
import script from "./UserResults.vue?vue&type=script&lang=js"
export * from "./UserResults.vue?vue&type=script&lang=js"

import "./UserResults.vue?vue&type=style&index=0&id=540be1c7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__